import { readStored, writeStored } from "@/lib/storage";

import type { Persistence } from "./context";
import { identityStateSchema, type IdentityState } from "./state";

/** localStorage under a versioned key, validated on read; other tabs' writes arrive as `storage` events. */
export function browserPersistence(key: string): Persistence {
  return {
    load: () => readStored(key, identityStateSchema),
    save: (state) => {
      writeStored(key, state);
    },
    watch: (onChange) => {
      const handler = (event: StorageEvent) => {
        if (event.key === key) onChange();
      };
      window.addEventListener("storage", handler);
      return () => {
        window.removeEventListener("storage", handler);
      };
    },
  };
}

/** In-memory persistence for tests. */
export function memoryPersistence(initial?: IdentityState): Persistence {
  let stored = initial === undefined ? undefined : structuredClone(initial);
  return {
    load: () => (stored === undefined ? undefined : structuredClone(stored)),
    save: (state) => {
      stored = structuredClone(state);
    },
    watch: () => () => undefined,
  };
}
